import type { SalaryTableBand } from "@shared/schema";

/**
 * Match a job level value (e.g. `L3_IC`, `L3_MGMT`) to a salary table band.
 *
 * The job level dropdown emits suffixed values (`<level>_<track>`) where
 * `track` is `IC` or `MGMT`. Bands in prod are typically registered by
 * level only (`L0`, `L1`, …, `L9`) because the underlying band table
 * doesn't distinguish IC from MGMT — both tracks share the same numeric
 * range at a given level. Try an exact match first (so an admin who *did*
 * register suffixed keys still wins), then fall back to the level prefix
 * before the underscore.
 *
 * Returns `undefined` when no band matches.
 */
export function findMatchingBand(
  bands: SalaryTableBand[],
  jobLevel: string,
): SalaryTableBand | undefined {
  if (!jobLevel) return undefined;
  const exact = bands.find((b) => b.key === jobLevel);
  if (exact) return exact;
  const prefix = jobLevel.split("_")[0];
  if (prefix && prefix !== jobLevel) {
    return bands.find((b) => b.key === prefix);
  }
  return undefined;
}
